import { useParams } from "react-router";
import { useState, useEffect } from 'react';
import Navigation from "./Navigation.jsx";
import TestComponent from "./TestComponent.jsx";
import Header from "./Header.jsx";
import { getSession } from "../services/session";

const TestPage = (props) => {
    let dData, paramVars, bData;
    paramVars = useParams();

    dData = getSession();

    return (<>
        <TestComponent />
        </>
    );
};

export default TestPage;